import './styles/NetworkRestrictionAlert.scss';

import { EnvelopeSimple, PushPin } from '@phosphor-icons/react';
import { Alert } from '@whistler-ui/k2/components/Alert';
import { Stack } from '@whistler-ui/k2/components/Stack';
import { Paragraph } from '@whistler-ui/k2/components/Typography';
import { useClassHelper } from '@whistler-ui/k2/hooks';

import { useGetWhiteListUrls } from '../../hooks';
import { inAuthWidget } from '../../routes/Root';

const SUPPORT_EMAIL = 'support@netlync.com';

const componentName = 'c-NetworkRestrictionAlert';

export const NetworkRestrictionAlert = () => {
  const c = useClassHelper(componentName);

  const { data: whiteListUrls, isPending } = useGetWhiteListUrls();

  if (
    !inAuthWidget &&
    Array.isArray(whiteListUrls) &&
    whiteListUrls.length > 0 &&
    !isPending
  ) {
    return (
      <Alert title="Network Restriction" variant="error">
        <Stack direction="column" gap={4}>
          <Paragraph>
            Your corporate network is blocking required services, preventing
            sign up and log in.
          </Paragraph>
          <Stack direction="column" gap={2}>
            <Paragraph>
              Please ask your IT team to whitelist the following URLs:
            </Paragraph>
            <Stack
              tag="ul"
              direction="column"
              className={`${c(
                '__list',
                'list-disc',
                'list-outside',
              )} gap-[0.15rem]!`}
            >
              {whiteListUrls.map((endpoint, index) => {
                return (
                  <li key={`endpoint-${index}`}>
                    <Stack direction="row" gap={2} align="center">
                      <PushPin size={18} weight="fill" />
                      <Paragraph className={c('__endpoint')}>
                        <a href={endpoint} target="_blank" rel="noreferrer">
                          {endpoint}
                        </a>
                      </Paragraph>
                    </Stack>
                  </li>
                );
              })}
            </Stack>
          </Stack>

          <Paragraph className={c('__link-support-wrapper')}>
            <EnvelopeSimple size={18} weight="light" /> Need help? Contact{' '}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              target="_blank"
              rel="noreferrer"
            >
              {SUPPORT_EMAIL}
            </a>
          </Paragraph>
        </Stack>
      </Alert>
    );
  }

  return null;
};
